import React, {useState} from "react";
import {withNamespaces} from "react-i18next";
import { Table } from "react-bootstrap";
import {useExpanded, useTable} from 'react-table'

const HilightTable = (
    {
        columns,
        data,
        getTrProps = (state, rowInfo, column) => {},
        t,
        onClickRow = function(e, row) {},
        renderRowSubComponent
    }) => {

    const [selected] = useState(null);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        visibleColumns,
        rows,
        prepareRow,
    } = useTable({
        columns,
        data,
        autoResetExpanded: false,
        getTrProps,
    }, useExpanded);

    return(
        <Table bordered striped className="w-100 nowrap" {...getTableProps()} responsive>
            <thead>
            {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => {
                        const {render, show, getHeaderProps} = column;
                        return (
                            show !== false ?
                                <th {...getHeaderProps()}  className={column.headerClassName ? column.headerClassName : '' } style={column.styleHeader} >{t(render("Header"))}</th> :
                                <React.Fragment key={false}/>
                        );
                    })}
                </tr>
            ))}
            </thead>
            <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
                prepareRow(row);
                return (
                    <React.Fragment key={i}>
                        <tr {...getTrProps(selected, row, rows)} {...row.getRowProps()} >
                            {row.cells.map(cell => {
                                return cell.column.show !== false ?
                                     <td {...cell.getCellProps()} className={cell.column.classNameRow} style={cell.column.styleRow}>{cell.render("Cell")}</td> :
                                    <React.Fragment key={false}/>
                            })}
                        </tr>
                        {row.isExpanded && (
                            <tr>
                                <td colSpan={visibleColumns.length}>{renderRowSubComponent(row)}</td>
                            </tr>
                        )}
                    </React.Fragment>
                )
            })}
            </tbody>
        </Table>
    )
};
export default withNamespaces()(HilightTable);
